module.exports = __webpack_public_path__ + "static/img/s145.e8f84e4e.png";